import PP from "./pp"
import TOS from "./tos"

//If a module specifies a routes.js, it can export an object
//where the keys are the paths and the values are the components
// Register all routes at once using an object
export default {
    "/privacy-policy": PP,
    "/privacy-policy/terms-of-use": TOS,
    "/terms-of-use": TOS,
}